import { Outlet, createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/_layout/quizzes")({
  component: QuizzesLayout,
})

function QuizzesLayout() {
  return <Outlet />
}
